export enum PayMode {
    Employee = "Employee",
    Vendor = "Vendor"
  }